export const Configs = {
  DefaultPageIndex: 1,
  DefaultPageSize: 20,
  DefaultPageSizeOption: [10, 20, 50],
  DefaultCapacityFile: 5000000,
  DefaultSortExpression: "modifiedDate desc",
  DefaultOrder: "desc",
  DefaultOrderBy: "modifiedDate",
  fileDocument: 300,
};

export const EmailConfig = {
  emptyAttribute: "Không có",
  update: "Cập nhật",
  save: "Lưu",
};

export const regex = {
  specialCharacter: "/([^@!#$%^&*()*-])w+/",
};
